import $ from "jquery";

export default function anchorScrollInit() {
    $('a[href^="#"]').on('click', function (event) {
        const targetId = $(this).attr('href');
        if (targetId.length < 2) return;
        event.preventDefault();

        const targetElement = $(targetId);

        if (targetElement.length) {
            const header = $('header.header');
            const targetPosition =
                targetElement.offset().top - header.get(0).clientHeight;

            $('html, body').animate(
                {
                    scrollTop: targetPosition,
                },
                500
            );
        }
    });
}